import client from 'app/client';
import { GroupContractProcessResponse } from '../types/enums';

/**
 * Fetches the subscription process state for a group contract (steps + current step).
 *
 * TODO(group-contract-v1): replace with the typed OpenAPI client once
 * `docs/api/risk.yaml` is updated to expose
 * `GET /api/backoffice/process-souscriptions/groupes/{contratGroupeId}/steps`.
 * The back returns the same shape as `GetProcessSouscriptionResponse`,
 * with `riskId = groupContractId` and `branchCode = type` ("G" or "C").
 */
export async function getGroupContractProcess(
  groupContractId: string,
): Promise<GroupContractProcessResponse> {
  const { data } = await client.get(
    `/backoffice/process-souscriptions/groupes/${groupContractId}/steps`,
  );

  const subscriptionState = data.subscriptionState ?? {};

  return {
    groupContractId: data.riskId ?? groupContractId,
    type: data.branchCode === 'G' ? 'GROUP' : 'CADRE',
    steps: subscriptionState.steps ?? [],
    currentStepIdentifier: subscriptionState.currentStepIdentifier,
    highestAccessibleStep: subscriptionState.highestAccessibleStep,
    isProcessCompleted: subscriptionState.isProcessCompleted ?? false,
  };
}
